import './PracticeHelpPopup.css';


const PracticeHelpPopup = ({ text, onClose }) => {
  return (
    <div className="practice-help-overlay">
      <div className="practice-help-modal">

        <button className="practice-help-close" onClick={onClose}>
          ✕
        </button>

       

        <div className="practice-help-content">
          <div
            dangerouslySetInnerHTML={{
              __html: text || ''
            }}
          />
        </div>

        <button className="practice-help-ok" onClick={onClose}>
          Am inteles
        </button>
      </div>
    </div>
  );
};

export default PracticeHelpPopup;
